module.exports = __webpack_public_path__ + "static/mace_of_disruption-365a3e0c9d6fd235beb08f15cd6b7be2.jpeg";